import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function CGUPage() {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <Link to="/" className="legal-back">
          <ArrowLeft size={16} /> Retour à l'accueil
        </Link>

        <h1 className="legal-title">Conditions Générales d'Utilisation</h1>
        <p className="legal-updated">Dernière mise à jour : mars 2026</p>

        <section className="legal-section">
          <h2>Article 1 — Objet</h2>
          <p>
            Les présentes Conditions Générales d'Utilisation (CGU) régissent l'accès et l'utilisation
            de la plateforme <strong>LoL Arena</strong>, accessible à l'adresse lol-arena.fr.
            LoL Arena est une plateforme communautaire permettant d'organiser et de participer à
            des tournois League of Legends.
          </p>
          <p>
            En vous inscrivant ou en utilisant le service, vous acceptez sans réserve les présentes CGU.
          </p>
        </section>

        <section className="legal-section">
          <h2>Article 2 — Accès au service</h2>
          <p>
            L'accès à LoL Arena est gratuit et ouvert à toute personne possédant un compte
            Riot Games ou Discord valide. La plateforme est accessible 24h/24 et 7j/7, sous réserve de
            maintenance ou d'interruption technique.
          </p>
          <p>
            L'utilisation du service requiert d'avoir au minimum <strong>13 ans</strong>, conformément
            aux conditions d'utilisation de Riot Games. Les mineurs de moins de 16 ans doivent
            obtenir l'accord d'un représentant légal.
          </p>
        </section>

        <section className="legal-section">
          <h2>Article 3 — Compte utilisateur</h2>
          <p>
            L'inscription se fait via votre compte <strong>Riot Games</strong> ou votre compte{' '}
            <strong>Discord</strong> (authentification OAuth2). Vous êtes responsable de la
            confidentialité de votre session et de toutes les actions effectuées depuis votre compte.
          </p>
          <p>
            Tout usage frauduleux, partage de compte ou tentative de manipulation des résultats
            entraîne la suspension immédiate du compte, sans préavis.
          </p>
        </section>

        <section className="legal-section">
          <h2>Article 4 — Règles de conduite</h2>
          <p>En utilisant LoL Arena, vous vous engagez à :</p>
          <ul>
            <li>Respecter les autres joueurs, organisateurs et membres de la communauté</li>
            <li>Ne pas utiliser de langage injurieux, discriminatoire ou haineux</li>
            <li>Ne pas tricher, utiliser des bots ou des programmes tiers non autorisés</li>
            <li>Ne pas usurper l'identité d'un autre joueur ou organisateur</li>
            <li>Respecter les règles spécifiques de chaque tournoi</li>
            <li>Ne pas perturber le bon fonctionnement de la plateforme</li>
          </ul>
          <p>
            Le non-respect de ces règles peut entraîner un avertissement, une suspension temporaire
            ou un bannissement définitif, à la discrétion des modérateurs.
          </p>
        </section>

        <section className="legal-section">
          <h2>Article 5 — Organisation de tournois</h2>
          <p>
            Tout utilisateur peut créer et organiser un tournoi sur la plateforme. L'organisateur
            est responsable de la bonne conduite du tournoi, du respect des règles annoncées et
            de la communication avec les participants.
          </p>
          <p>
            LoL Arena se réserve le droit de supprimer tout tournoi dont le contenu serait contraire
            aux présentes CGU ou aux lois en vigueur.
          </p>
        </section>

        <section className="legal-section">
          <h2>Article 6 — Propriété intellectuelle</h2>
          <p>
            L'ensemble des éléments constitutifs de LoL Arena (code, design, logo) est la propriété
            exclusive de son éditeur. Toute reproduction est interdite sans autorisation écrite préalable.
          </p>
          <p>
            League of Legends et tous les éléments associés sont la propriété de{' '}
            <strong>Riot Games, Inc.</strong> LoL Arena utilise l'API Riot Games conformément à
            leurs politiques et n'est en aucun cas affilié ou approuvé par Riot Games.
          </p>
        </section>

        <section className="legal-section">
          <h2>Article 7 — Limitation de responsabilité</h2>
          <p>
            LoL Arena est fourni "en l'état", sans garantie d'aucune sorte. L'éditeur ne peut être
            tenu responsable de toute perte ou dommage résultant de l'utilisation ou de l'impossibilité
            d'utiliser le service.
          </p>
          <p>
            LoL Arena n'est pas responsable des litiges entre joueurs ou équipes dans le cadre
            des tournois organisés sur la plateforme.
          </p>
        </section>

        <section className="legal-section">
          <h2>Article 8 — Modification des CGU</h2>
          <p>
            L'éditeur se réserve le droit de modifier les présentes CGU à tout moment. Les utilisateurs
            seront informés des changements significatifs. La poursuite de l'utilisation du service
            après modification vaut acceptation des nouvelles CGU.
          </p>
        </section>

        <section className="legal-section">
          <h2>Article 9 — Droit applicable</h2>
          <p>
            Les présentes CGU sont soumises au droit français. Tout litige sera soumis à la
            compétence exclusive des tribunaux français.
          </p>
        </section>
      </div>
    </div>
  );
}
